export const email = /^[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
export const password = /^(?=.*[*.!@#$%^&(){}[\]:;<>,.?/~_+\-=|\\])(?=.*[A-Z])[0-9a-zA-Z*.!@#$%^&(){}[\]:;<>,.?/~_+-=|\\]{8,255}$/;
